import workspaceTokens from './styles/tokens';
import { chatSidebar, chatSidebarConversationActions } from './Chat/styles/sidebar';
import { chatHistory } from './Chat/styles/history';
import { chatThread } from './Chat/styles/thread';
import { chatComposer } from './Chat/styles/composer';
import { chatContentRowAndOverrides } from './Chat/styles/overrides';
import { chatDelegationDrawer } from './Chat/styles/delegationDrawer';
import { homeCards, homeViewAndFeed, homeCommandAdditions, homeComposer } from './styles/home';
import { heroEmptyState, heroEditableName } from './styles/hero';
import { agentConfigPage } from './AgentConfig/styles/agentPage';
import { agentConfigSettingsTakeover } from './AgentConfig/styles/settingsTakeover';
import { agentConfigEditFormAndPromotion } from './AgentConfig/styles/editForm';
import { contextLibrary } from './Context/styles/contextLibrary';
import { scrollbarAutohide } from './styles/scrollbar';
import { routinesAutomationPages } from './Routines/styles/automation';
import { organizationView, organizationOrgChartButton } from './styles/organization';
import { runsTaskQueue, runsPagination, runsActivityLog } from './styles/runs';
import { traceDrawer } from './styles/traceDrawer';
import { adminView, adminUsagePage } from './Admin/styles/admin';
import { legacyOverlayCloseBar } from './styles/legacyOverlay';

// Canonical composition of the AI Workspace stylesheet (WEB-7962 split).
// The fragment order below IS the original monolith's source order and is part
// of the CSS cascade — several fragments override earlier ones at equal
// specificity (e.g. chatContentRowAndOverrides, chatDelegationDrawer). Don't
// reorder, and add new fragments at the position their rules should cascade.
const workspaceStyles =
	workspaceTokens +
	chatSidebar +
	chatHistory +
	chatThread +
	homeCards +
	chatComposer +
	heroEmptyState +
	agentConfigPage +
	heroEditableName +
	scrollbarAutohide +
	chatSidebarConversationActions +
	chatContentRowAndOverrides +
	homeViewAndFeed +
	routinesAutomationPages +
	organizationView +
	runsTaskQueue +
	runsPagination +
	runsActivityLog +
	traceDrawer +
	homeCommandAdditions +
	agentConfigEditFormAndPromotion +
	organizationOrgChartButton +
	adminView +
	agentConfigSettingsTakeover +
	contextLibrary +
	homeComposer +
	adminUsagePage +
	legacyOverlayCloseBar +
	chatDelegationDrawer;

export default workspaceStyles;
